import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, ChevronLeft, ChevronRight, ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// Country code to flag emoji mapping
const COUNTRY_FLAGS = {
  "AF": "🇦🇫", "AL": "🇦🇱", "DZ": "🇩🇿", "AD": "🇦🇩", "AO": "🇦🇴",
  "AG": "🇦🇬", "AR": "🇦🇷", "AM": "🇦🇲", "AU": "🇦🇺", "AT": "🇦🇹",
  "AZ": "🇦🇿", "BS": "🇧🇸", "BH": "🇧🇭", "BD": "🇧🇩", "BB": "🇧🇧",
  "BY": "🇧🇾", "BE": "🇧🇪", "BZ": "🇧🇿", "BJ": "🇧🇯", "BT": "🇧🇹",
  "BO": "🇧🇴", "BA": "🇧🇦", "BW": "🇧🇼", "BR": "🇧🇷", "BN": "🇧🇳",
  "BG": "🇧🇬", "BF": "🇧🇫", "BI": "🇧🇮", "CV": "🇨🇻", "KH": "🇰🇭",
  "CM": "🇨🇲", "CA": "🇨🇦", "CF": "🇨🇫", "TD": "🇹🇩", "CL": "🇨🇱",
  "CN": "🇨🇳", "CO": "🇨🇴", "KM": "🇰🇲", "CG": "🇨🇬", "CD": "🇨🇩",
  "CR": "🇨🇷", "CI": "🇨🇮", "HR": "🇭🇷", "CU": "🇨🇺", "CY": "🇨🇾",
  "CZ": "🇨🇿", "DK": "🇩🇰", "DJ": "🇩🇯", "DM": "🇩🇲", "DO": "🇩🇴",
  "EC": "🇪🇨", "EG": "🇪🇬", "SV": "🇸🇻", "GQ": "🇬🇶", "ER": "🇪🇷",
  "EE": "🇪🇪", "SZ": "🇸🇿", "ET": "🇪🇹", "FJ": "🇫🇯", "FI": "🇫🇮",
  "FR": "🇫🇷", "GA": "🇬🇦", "GM": "🇬🇲", "GE": "🇬🇪", "DE": "🇩🇪",
  "GH": "🇬🇭", "GR": "🇬🇷", "GD": "🇬🇩", "GT": "🇬🇹", "GN": "🇬🇳",
  "GW": "🇬🇼", "GY": "🇬🇾", "HT": "🇭🇹", "HN": "🇭🇳", "HK": "🇭🇰",
  "HU": "🇭🇺", "IS": "🇮🇸", "IN": "🇮🇳", "ID": "🇮🇩", "IR": "🇮🇷",
  "IQ": "🇮🇶", "IE": "🇮🇪", "IL": "🇮🇱", "IT": "🇮🇹", "JM": "🇯🇲",
  "JP": "🇯🇵", "JO": "🇯🇴", "KZ": "🇰🇿", "KE": "🇰🇪", "KI": "🇰🇮",
  "KP": "🇰🇵", "KR": "🇰🇷", "KW": "🇰🇼", "KG": "🇰🇬", "LA": "🇱🇦",
  "LV": "🇱🇻", "LB": "🇱🇧", "LS": "🇱🇸", "LR": "🇱🇷", "LY": "🇱🇾",
  "LI": "🇱🇮", "LT": "🇱🇹", "LU": "🇱🇺", "MO": "🇲🇴", "MG": "🇲🇬",
  "MW": "🇲🇼", "MY": "🇲🇾", "MV": "🇲🇻", "ML": "🇲🇱", "MT": "🇲🇹",
  "MH": "🇲🇭", "MR": "🇲🇷", "MU": "🇲🇺", "MX": "🇲🇽", "FM": "🇫🇲",
  "MD": "🇲🇩", "MC": "🇲🇨", "MN": "🇲🇳", "ME": "🇲🇪", "MA": "🇲🇦",
  "MZ": "🇲🇿", "MM": "🇲🇲", "NA": "🇳🇦", "NR": "🇳🇷", "NP": "🇳🇵",
  "NL": "🇳🇱", "NZ": "🇳🇿", "NI": "🇳🇮", "NE": "🇳🇪", "NG": "🇳🇬",
  "MK": "🇲🇰", "NO": "🇳🇴", "OM": "🇴🇲", "PK": "🇵🇰", "PW": "🇵🇼",
  "PS": "🇵🇸", "PA": "🇵🇦", "PG": "🇵🇬", "PY": "🇵🇾", "PE": "🇵🇪",
  "PH": "🇵🇭", "PL": "🇵🇱", "PT": "🇵🇹", "PR": "🇵🇷", "QA": "🇶🇦",
  "RO": "🇷🇴", "RU": "🇷🇺", "RW": "🇷🇼", "KN": "🇰🇳", "LC": "🇱🇨",
  "VC": "🇻🇨", "WS": "🇼🇸", "SM": "🇸🇲", "ST": "🇸🇹", "SA": "🇸🇦",
  "SN": "🇸🇳", "RS": "🇷🇸", "SC": "🇸🇨", "SL": "🇸🇱", "SG": "🇸🇬",
  "SK": "🇸🇰", "SI": "🇸🇮", "SB": "🇸🇧", "SO": "🇸🇴", "ZA": "🇿🇦",
  "SS": "🇸🇸", "ES": "🇪🇸", "LK": "🇱🇰", "SD": "🇸🇩", "SR": "🇸🇷",
  "SE": "🇸🇪", "CH": "🇨🇭", "SY": "🇸🇾", "TW": "🇹🇼", "TJ": "🇹🇯",
  "TZ": "🇹🇿", "TH": "🇹🇭", "TL": "🇹🇱", "TG": "🇹🇬", "TO": "🇹🇴",
  "TT": "🇹🇹", "TN": "🇹🇳", "TR": "🇹🇷", "TM": "🇹🇲", "TV": "🇹🇻",
  "UG": "🇺🇬", "UA": "🇺🇦", "AE": "🇦🇪", "GB": "🇬🇧", "US": "🇺🇸",
  "UY": "🇺🇾", "UZ": "🇺🇿", "VU": "🇻🇺", "VA": "🇻🇦", "VE": "🇻🇪",
  "VN": "🇻🇳", "YE": "🇾🇪", "ZM": "🇿🇲", "ZW": "🇿🇼",
};

// Country code to country name mapping
const COUNTRY_NAMES = {
  "AF": "Afghanistan", "AL": "Albania", "DZ": "Algeria", "AD": "Andorra", "AO": "Angola",
  "AG": "Antigua and Barbuda", "AR": "Argentina", "AM": "Armenia", "AU": "Australia", "AT": "Austria",
  "AZ": "Azerbaijan", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados",
  "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BT": "Bhutan",
  "BO": "Bolivia", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BR": "Brazil", "BN": "Brunei",
  "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "CV": "Cabo Verde", "KH": "Cambodia",
  "CM": "Cameroon", "CA": "Canada", "CF": "Central African Republic", "TD": "Chad", "CL": "Chile",
  "CN": "China", "CO": "Colombia", "KM": "Comoros", "CG": "Congo", "CD": "Congo (DRC)",
  "CR": "Costa Rica", "CI": "Côte d'Ivoire", "HR": "Croatia", "CU": "Cuba", "CY": "Cyprus",
  "CZ": "Czech Republic", "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic",
  "EC": "Ecuador", "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea",
  "EE": "Estonia", "SZ": "Eswatini", "ET": "Ethiopia", "FJ": "Fiji", "FI": "Finland",
  "FR": "France", "GA": "Gabon", "GM": "Gambia", "GE": "Georgia", "DE": "Germany",
  "GH": "Ghana", "GR": "Greece", "GD": "Grenada", "GT": "Guatemala", "GN": "Guinea",
  "GW": "Guinea-Bissau", "GY": "Guyana", "HT": "Haiti", "HN": "Honduras", "HK": "Hong Kong",
  "HU": "Hungary", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IR": "Iran",
  "IQ": "Iraq", "IE": "Ireland", "IL": "Israel", "IT": "Italy", "JM": "Jamaica",
  "JP": "Japan", "JO": "Jordan", "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati",
  "KP": "North Korea", "KR": "South Korea", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Laos",
  "LV": "Latvia", "LB": "Lebanon", "LS": "Lesotho", "LR": "Liberia", "LY": "Libya",
  "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MO": "Macau", "MG": "Madagascar",
  "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta",
  "MH": "Marshall Islands", "MR": "Mauritania", "MU": "Mauritius", "MX": "Mexico", "FM": "Micronesia",
  "MD": "Moldova", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MA": "Morocco",
  "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal",
  "NL": "Netherlands", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria",
  "MK": "North Macedonia", "NO": "Norway", "OM": "Oman", "PK": "Pakistan", "PW": "Palau",
  "PS": "Palestine", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru",
  "PH": "Philippines", "PL": "Poland", "PT": "Portugal", "PR": "Puerto Rico", "QA": "Qatar",
  "RO": "Romania", "RU": "Russia", "RW": "Rwanda", "KN": "Saint Kitts and Nevis", "LC": "Saint Lucia",
  "VC": "Saint Vincent and the Grenadines", "WS": "Samoa", "SM": "San Marino", "ST": "Sao Tome and Principe", "SA": "Saudi Arabia",
  "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore",
  "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia", "ZA": "South Africa",
  "SS": "South Sudan", "ES": "Spain", "LK": "Sri Lanka", "SD": "Sudan", "SR": "Suriname",
  "SE": "Sweden", "CH": "Switzerland", "SY": "Syria", "TW": "Taiwan", "TJ": "Tajikistan",
  "TZ": "Tanzania", "TH": "Thailand", "TL": "Timor-Leste", "TG": "Togo", "TO": "Tonga",
  "TT": "Trinidad and Tobago", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TV": "Tuvalu",
  "UG": "Uganda", "UA": "Ukraine", "AE": "United Arab Emirates", "GB": "United Kingdom", "US": "United States",
  "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VA": "Vatican City", "VE": "Venezuela",
  "VN": "Vietnam", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe",
};

export default function HomePage() {
  const location = useLocation();
  const [games, setGames] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [availableLetters, setAvailableLetters] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [sortOrder, setSortOrder] = useState("alphabetical");
  const [loading, setLoading] = useState(true);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [carouselGames, setCarouselGames] = useState([]);
  const [letterDropdownOpen, setLetterDropdownOpen] = useState(false);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const gamesGridRef = React.useRef(null);
  const letterRefs = React.useRef({});
  const gameCardRefs = React.useRef({});

  // Handle hash navigation to scroll to specific game
  useEffect(() => {
    if (location.hash && games.length > 0) {
      const gameId = location.hash.replace('#game-', '');
      const gameCardEl = gameCardRefs.current[gameId];
      if (gameCardEl) {
        setTimeout(() => {
          gameCardEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
  }, [location.hash, games]);

  // Shuffle games for carousel (randomize order)
  useEffect(() => {
    if (games.length > 0) {
      const shuffled = [...games].sort(() => Math.random() - 0.5);
      setCarouselGames(shuffled);
      setCarouselIndex(0);
    }
  }, [games]);

  const fetchGames = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (searchQuery) params.append("search", searchQuery);
      params.append("category", "game");
      if (selectedCountry) params.append("country", selectedCountry);
      params.append("sort", sortOrder);
      
      const response = await axios.get(`${API}/games?${params.toString()}`);
      setGames(response.data);
    } catch (error) {
      console.error("Error fetching games:", error);
      setGames([]);
    } finally {
      setLoading(false);
    }
  }, [searchQuery, selectedCountry, sortOrder]);

  const fetchAvailableCountries = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/games/countries/available?category=game`);
      setAvailableCountries(response.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setAvailableCountries([]);
    }
  }, []);

  const fetchAvailableLetters = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/games/letters/available?category=game`);
      if (response.data.length === 0 && games.length > 0) {
        const letters = [...new Set(games.map(g => g.name[0].toUpperCase()).filter(l => /[A-Z]/.test(l)))];
        setAvailableLetters(letters.sort());
      } else {
        setAvailableLetters(response.data);
      }
    } catch (error) {
      console.error("Error fetching letters:", error);
      const letters = [...new Set(games.map(g => g.name[0].toUpperCase()).filter(l => /[A-Z]/.test(l)))];
      setAvailableLetters(letters.length > 0 ? letters.sort() : []);
    }
  }, [games]);

  useEffect(() => {
    fetchGames();
  }, [fetchGames]);

  useEffect(() => {
    fetchAvailableCountries();
  }, [fetchAvailableCountries]);

  useEffect(() => {
    if (games.length > 0) {
      fetchAvailableLetters();
    }
  }, [games, fetchAvailableLetters]);

  // Carousel auto-rotation every 10 seconds, reset on manual navigation
  const [carouselKey, setCarouselKey] = useState(0);
  
  useEffect(() => {
    if (carouselGames.length === 0) return;
    const interval = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % carouselGames.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [carouselGames.length, carouselKey]);

  const nextSlide = () => {
    setCarouselIndex((prev) => (prev + 1) % carouselGames.length);
    setCarouselKey((prev) => prev + 1); // Reset timer
  };

  const prevSlide = () => {
    setCarouselIndex((prev) => (prev - 1 + carouselGames.length) % carouselGames.length);
    setCarouselKey((prev) => prev + 1); // Reset timer
  };

  const handleLetterClick = (letter) => {
    setLetterDropdownOpen(false);
    
    if (letter === null) {
      // Show all - scroll to top of grid
      if (gamesGridRef.current) {
        gamesGridRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    
    // Find the first game starting with this letter and scroll to it
    const letterRef = letterRefs.current[letter];
    if (letterRef) {
      letterRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Track views
  const trackView = async (gameId) => {
    try {
      await axios.post(`${API}/analytics`, { game_id: gameId, event_type: 'view' });
    } catch (error) {
      // Silent fail for analytics
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Carousel - All games featured */}
      {carouselGames.length > 0 && (
        <section 
          className="relative h-[400px] md:h-[500px] bg-[#7C3AED] overflow-hidden"
          data-testid="hero-carousel"
        >
          {carouselGames.map((game, index) => (
            <Link
              key={game.id}
              to={`/game/${game.id}`}
              onClick={() => trackView(game.id)}
              className={`absolute inset-0 transition-opacity duration-700 cursor-pointer ${
                index === carouselIndex ? "opacity-100 z-10 pointer-events-auto" : "opacity-0 z-0 pointer-events-none"
              }`}
            >
              <img
                src={game.image_url}
                alt={game.name}
                className="w-full h-full object-cover opacity-50"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#7C3AED] via-[#7C3AED]/60 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-8 md:p-16">
                <div className="max-w-7xl mx-auto">
                  <h2 className="font-serif font-bold text-3xl md:text-5xl text-white mb-3">
                    {game.name}
                  </h2>
                  <p className="font-sans text-slate-200 text-lg mb-6 max-w-xl">
                    {game.strap_line || game.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}

          {/* Transparent Outline Carousel Controls */}
          <button
            onClick={(e) => { e.preventDefault(); prevSlide(); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 border-2 border-white/50 rounded-full flex items-center justify-center text-white/70 hover:border-white hover:text-white transition-colors z-20"
            data-testid="carousel-prev"
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={(e) => { e.preventDefault(); nextSlide(); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 border-2 border-white/50 rounded-full flex items-center justify-center text-white/70 hover:border-white hover:text-white transition-colors z-20"
            data-testid="carousel-next"
            aria-label="Next slide"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          {/* Carousel Indicators */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
            {carouselGames.slice(0, Math.min(10, carouselGames.length)).map((_, index) => (
              <button
                key={index}
                onClick={(e) => { e.preventDefault(); setCarouselIndex(index); }}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === carouselIndex % Math.min(10, carouselGames.length)
                    ? "bg-white w-8"
                    : "bg-white/40 hover:bg-white/60"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </section>
      )}

      {/* Search Section */}
      <section className="py-12 md:py-16 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-serif font-bold text-3xl md:text-4xl text-slate-900 mb-4">
              Discover Amazing Games
            </h2>
            <p className="font-sans text-slate-600 text-lg max-w-2xl mx-auto">
              Browse our collection of self-published board games from talented creators worldwide
            </p>
          </div>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto mb-8">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input
                type="text"
                placeholder="Search games by name..."
                value={searchQuery}
                onChange={handleSearch}
                className="w-full pl-12 pr-4 py-4 h-14 rounded-full border-2 border-stone-200 focus:border-[#7C3AED] focus:ring-4 focus:ring-[#7C3AED]/10 bg-white text-lg font-sans"
                data-testid="search-input"
              />
            </div>
          </div>

          {/* Filter & Sort Controls */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {/* Country Filter */}
            <DropdownMenu open={countryDropdownOpen} onOpenChange={setCountryDropdownOpen}>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  className="rounded-full px-4 py-2 font-sans border-2 border-stone-200 hover:border-[#7C3AED] hover:text-[#7C3AED]"
                  data-testid="country-filter-trigger"
                >
                  {selectedCountry ? (
                    <>
                      {COUNTRY_FLAGS[selectedCountry]} {COUNTRY_NAMES[selectedCountry]}
                    </>
                  ) : (
                    <>🌍 All Countries</>
                  )}
                  <ChevronDown className="w-4 h-4 ml-2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="center" className="max-h-80 overflow-y-auto">
                <DropdownMenuItem 
                  onClick={() => { setSelectedCountry(""); setCountryDropdownOpen(false); }}
                  className="cursor-pointer"
                >
                  🌍 All Countries
                </DropdownMenuItem>
                {availableCountries.map((code) => (
                  <DropdownMenuItem 
                    key={code}
                    onClick={() => { setSelectedCountry(code); setCountryDropdownOpen(false); }}
                    className="cursor-pointer"
                  >
                    {COUNTRY_FLAGS[code]} {COUNTRY_NAMES[code]}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>

            {/* Sort Order */}
            <DropdownMenu open={sortDropdownOpen} onOpenChange={setSortDropdownOpen}>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  className="rounded-full px-4 py-2 font-sans border-2 border-stone-200 hover:border-[#7C3AED] hover:text-[#7C3AED]"
                  data-testid="sort-order-trigger"
                >
                  {sortOrder === "alphabetical" && "A-Z Alphabetical"}
                  {sortOrder === "newest" && "Newest First"}
                  {sortOrder === "oldest" && "Oldest First"}
                  <ChevronDown className="w-4 h-4 ml-2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="center">
                <DropdownMenuItem 
                  onClick={() => { setSortOrder("alphabetical"); setSortDropdownOpen(false); }}
                  className="cursor-pointer"
                >
                  A-Z Alphabetical
                </DropdownMenuItem>
                <DropdownMenuItem 
                  onClick={() => { setSortOrder("newest"); setSortDropdownOpen(false); }}
                  className="cursor-pointer"
                >
                  Newest First
                </DropdownMenuItem>
                <DropdownMenuItem 
                  onClick={() => { setSortOrder("oldest"); setSortDropdownOpen(false); }}
                  className="cursor-pointer"
                >
                  Oldest First
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            {/* Clear Filters */}
            {(selectedCountry || sortOrder !== "alphabetical") && (
              <Button
                variant="ghost"
                className="rounded-full px-4 py-2 font-sans text-slate-500 hover:text-[#7C3AED]"
                onClick={() => { setSelectedCountry(""); setSortOrder("alphabetical"); }}
                data-testid="clear-filters"
              >
                Clear Filters
              </Button>
            )}
          </div>

          {/* Games Grid */}
          <div ref={gamesGridRef} className="scroll-mt-24">
          {loading ? (
            <div className="games-grid">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-white rounded-2xl overflow-hidden border border-stone-200">
                  <div className="skeleton h-48 w-full" />
                  <div className="p-6">
                    <div className="skeleton h-6 w-3/4 mb-2 rounded" />
                    <div className="skeleton h-4 w-full rounded" />
                  </div>
                </div>
              ))}
            </div>
          ) : games.length > 0 ? (
            <div className="games-grid stagger-children" data-testid="games-grid">
              {games.map((game, index) => {
                const firstLetter = game.name[0].toUpperCase();
                const isFirstOfLetter = index === 0 || games[index - 1].name[0].toUpperCase() !== firstLetter;
                
                return (
                  <Link
                    key={game.id}
                    to={`/game/${game.id}`}
                    onClick={() => trackView(game.id)}
                    ref={(el) => {
                      gameCardRefs.current[game.id] = el;
                      if (isFirstOfLetter) {
                        letterRefs.current[firstLetter] = el;
                      }
                    }}
                    className="game-card group bg-white rounded-2xl overflow-hidden border border-stone-200 shadow-sm scroll-mt-24"
                    data-testid={`game-card-${game.id}`}
                    aria-label={`View ${game.name}`}
                  >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={game.image_url}
                      alt={game.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    {game.country && COUNTRY_FLAGS[game.country] && (
                      <div 
                        className="absolute bottom-2 right-2 text-2xl drop-shadow-lg"
                        title={game.country}
                      >
                        {COUNTRY_FLAGS[game.country]}
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif font-bold text-xl text-slate-900 mb-2 group-hover:text-[#7C3AED] transition-colors">
                      {game.name}
                    </h3>
                    <p className="font-sans text-slate-600 text-sm line-clamp-2">
                      {game.strap_line || game.description}
                    </p>
                  </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-16">
              <h3 className="font-serif font-bold text-xl text-slate-900 mb-2">
                No games found
              </h3>
              <p className="font-sans text-slate-600">
                {searchQuery
                  ? "Try adjusting your search"
                  : "Be the first to add a game!"}
              </p>
            </div>
          )}
          </div>
        </div>
      </section>

      {/* Dropdown Letter Navigation */}
      <nav 
        className="sticky bottom-0 z-50 bg-white/95 backdrop-blur-xl border-t border-stone-200 py-4 px-4"
        data-testid="letter-nav"
        aria-label="Filter games by letter"
      >
        <div className="max-w-7xl mx-auto flex justify-center">
          <DropdownMenu open={letterDropdownOpen} onOpenChange={setLetterDropdownOpen}>
            <DropdownMenuTrigger asChild>
              <Button
                variant="outline"
                className="rounded-full px-6 py-3 font-sans font-bold border-2 border-[#7C3AED] text-[#7C3AED] hover:bg-[#7C3AED] hover:text-white"
                data-testid="letter-dropdown-trigger"
              >
                Jump to Letter
                <ChevronDown className="w-4 h-4 ml-2" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="center" className="w-80 max-h-80 overflow-y-auto">
              <div className="grid grid-cols-7 gap-1 p-2">
                {ALPHABET.map((letter) => {
                  const hasGames = availableLetters.includes(letter);
                  return (
                    <button
                      key={letter}
                      onClick={() => hasGames && handleLetterClick(letter)}
                      disabled={!hasGames}
                      className={`w-8 h-8 flex items-center justify-center rounded text-sm font-sans font-bold transition-colors ${
                        hasGames
                          ? "text-slate-600 hover:bg-[#7C3AED] hover:text-white"
                          : "text-slate-300 cursor-not-allowed"
                      }`}
                      data-testid={`letter-${letter}`}
                    >
                      {letter}
                    </button>
                  );
                })}
              </div>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </nav>
    </div>
  );
}
